<template>
  <b-card no-body class="p-3 mb-2">
    <b-row class="no-gutters align-items-center">
      <b-col class="col-auto mr-3">
        <img :src="clientTypeImg" class="user__icon" />
      </b-col>
      <b-col>
        <div class="font-weight-bold">
          {{ clientFullName }}
        </div>
        <div class="small">
          <div v-if="!isClientMultiuser">
            <span class="mr-3">
              {{ client.registration.email }}
            </span>
            <span>{{ client.phone }}</span>
          </div>
          <div v-else>
            <span class="mr-3">{{ $t("multiUser") }}</span>
            <span class="mr-3">{{ clientCompanyName }}</span>
          </div>
          <div v-if="!isClientPredict">
            <span>{{$t("clientType")}}: <b>{{ clientType }}</b></span>
          </div>
        </div>
      </b-col>
      <b-col class="col-auto">
        <b-button class="mr-1 mb-1" size="sm" variant="outline-primary" @click="viewClientProjects">
          {{ $t("button.projects") }}
        </b-button>
      </b-col>
      <b-col v-if="isClientCustom" class="col-auto">
        <b-button class="mr-1 mb-1" size="sm" variant="outline-primary" @click="viewClientInvoices">
          {{ $t("button.invoices") }}
        </b-button>
      </b-col>
      <b-col class="col-auto">
        <b-button class="mb-1" size="sm" variant="outline-primary" @click="viewClientProfile">
          {{ $t("button.details") }}
        </b-button>
      </b-col>
      <b-col class="col-auto" v-if="isClientPredict">
        <b-button class="mb-1 ml-1" size="sm" variant="outline-primary" @click="openServiceSelectionModal">
          {{ $t("button.addSubscription") }}
        </b-button>
      </b-col>
      <b-col class="col-auto" v-if="isClientPredict">
        <b-button class="mb-1 ml-1" size="sm" variant="outline-warning" @click="sparksModal = true">
          ⚡ {{ availableSparks }}
        </b-button>
      </b-col>
    </b-row>
    <b-row
      v-if="isClientPredict && !isClientMultiuser && registrationUserId"
      class="no-gutters align-items-center mt-2"
    >
      <b-col class="col-12">
        <b-form-checkbox
          v-model="aiFeaturesDisabled"
          switch
          @change="onToggleAiFeatures"
        >
          <span class="text-muted small ml-2">
            {{ $t("disableAiFeatures") }}
          </span>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <select-services-modal :modalStatus="serviceModalStatus" @submit="subscribeToService"
      @setModalStatus="setServiceSelectionModalStatus">
    </select-services-modal>
    <client-sparks-modal
      v-if="isClientPredict"
      :visible="sparksModal"
      :client-id="client._id"
      :spark="clientSpark"
      @close="sparksModal = false"
      @updated="onSparksUpdated"
    />
  </b-card>
</template>

<script>
import Utils from "./../../Utils";
import services from "./../../services";
import SelectServicesModal from "../ServicesPredict/SelectServicesModal.vue";
import ClientSparksModal from "./ClientSparksModal.vue";
export default {
  components: {
    SelectServicesModal,
    ClientSparksModal,
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      serviceModal: false,
      sparksModal: false,
      aiFeaturesDisabled: !!(this.client.registration && this.client.registration.aiFeaturesDisabled),
    }
  },
  computed: {
    clientCompanyName() {
      return this.client.companyName;
    },
    clientFullName() {
      return this.client.firstName + " " + this.client.lastName;
    },
    isClientCustom() {
      return this.client.clientType === Utils.CLIENT_TYPE.CUSTOM;
    },
    isClientMultiuser() {
      return this.client.multiUser;
    },
    clientTypeImg() {
      if (this.isClientMultiuser) {
        return require("./../../assets/icons/users.svg");
      } else {
        return require("./../../assets/icons/user.svg");
      }
    },
    serviceModalStatus() {
      return this.serviceModal
    },
    isClientPredict(){
      return this.client.clientType === Utils.CLIENT_TYPE.PREDICT;
    },
    clientType(){
      return this.client.clientType
    },
    clientSpark() {
      return this.client.spark || { availableSparks: 0, totalSparks: 0, totalSparksUsed: 0 };
    },
    availableSparks() {
      return this.clientSpark.availableSparks;
    },
    registrationUserId() {
      return this.client.registration && this.client.registration._id;
    },
  },
  methods: {
    viewClientProjects() {
      this.$router.push({
        name: "ClientProjects",
        params: { id: this.client._id },
      });
    },
    viewClientInvoices() {
      this.$router.push({
        name: "ClientInvoices",
        params: { id: this.client._id },
      });
    },
    viewClientProfile() {
      this.$router.push({
        name: "EditClientAccount",
        params: { id: this.client._id },
      });
    },
    openServiceSelectionModal() {
      this.setServiceSelectionModalStatus(true)
    },
    setServiceSelectionModalStatus(status) {
      this.serviceModal = status
    },
    subscribeToService(serviceId) {
      const payload = {
        // expirationDate: "2026-06-12T13:20:45.699Z",
        clientId: this.client._id,
        serviceId: serviceId

      }
      this.$store.commit("loader/SET_LOADER", {});
      this.$store
        .dispatch("subscriptionPredict/createSubscription", payload)
        .catch((e) => { console.log(e) })
        .finally(() => this.$store.dispatch("loader/close"));
    },
    onSparksUpdated() {
      // The store already patches the client list; the modal stays open
      // so the employee can keep adjusting. Close manually if desired.
    },
    // Per-user "disable AI" for a single-user predict client: the client's
    // registration IS the (only) user, so toggle it directly here.
    onToggleAiFeatures(value) {
      if (!this.registrationUserId) return;
      this.$store.commit("loader/SET_LOADER", {});
      services.UserService.updateUser(this.registrationUserId, {
        aiFeaturesDisabled: value,
      })
        .then(() => {
          if (this.client.registration) this.client.registration.aiFeaturesDisabled = value;
          this.$store.commit("success/SET_SUCCESS_INFO", {});
        })
        .catch(() => {
          this.aiFeaturesDisabled = !value;
          this.$store.commit("error/SET_ERROR", {});
        })
        .finally(() => this.$store.dispatch("loader/close"));
    },
  },
};
</script>

<style scoped>
.user__icon {
  width: 20px;
  filter: invert(0%) sepia(85%) saturate(7500%) hue-rotate(173deg) brightness(87%) contrast(113%);
}
</style>
